import { fork } from 'redux-saga/effects'
import email from './email'

export default function *root() {
  yield [
    fork(email)
  ]
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js